module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Display3-0153607d4573033fa97676eada97d779.svg";